import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import PageBase from '../../../app/PageBase';
import Table from '../../table/MsTable';
import CompanyForm from './CompanyForm';
import { companyByUserId, deleteCompany, companyByHoldingId } from '../../../redux/actions/companyActions';
import DeleteConfirmationDialog from '../../util/Dialogs/DeleteConfirmationDialog';


import { setCompanyData } from '../../../redux/company';

const mapStateToProps = state => ({
  open: state.companyReducer.open,
  companyId: state.companyReducer.companyId,
  companyList: state.companyReducer.companyList,
});

const mapDispatchToProps = {
  setCompanyData,
  companyByUserId,
  deleteCompany,
  companyByHoldingId,
};

class CompanyContainer extends Component {


  static propTypes = {

  };

  constructor(props) {

    super(props);

    this.state = {
      data: {},
      deleteOpen: false,
      showTableActions: false,
    };

    this.onChangeData = this.onChangeData.bind(this);
    this.getCompany = this.getCompany.bind(this);
    this.closeDeleteDialog = this.closeDeleteDialog.bind(this);

  }


  componentWillMount() {

    this.getCompany();

  }

  getCompany() {

    const { user } = this.props;
    if (user.userTypeId === 1) this.getCompanyByHoldingId();

    else this.getCompanyByUserId();

  }

  getCompanyByHoldingId() {

    const { user, setCompanyData, companyByHoldingId } = this.props;

    companyByHoldingId(user.context.idHolding).then(response => setCompanyData({ companyList: response }));

  }

  getCompanyByUserId() {

    const { user, setCompanyData, companyByUserId } = this.props;

    companyByUserId(user.IdUser).then(response => setCompanyData({ companyList: response }));

  }

  onChangeData = (data) => {

    this.setState({ data, showTableActions: Object.keys(data).length !== 0 });
    this.props.setCompanyData({ companyId: data[Object.keys(data)[0]] ? data[Object.keys(data)[0]].idCompany : undefined, companyData: data[Object.keys(data)[0]] });

  }

  handleCreateClick = () => {

    this.props.history.push('/company/form/');
    this.props.setCompanyData({ companyId: null });

  }

  handleEditClick = () => {

    this.props.history.push('/company/form/');

  }

  handleDeleteClick = () => this.setState({ deleteOpen: true })

  closeDeleteDialog(confirmDelete) {

    if (confirmDelete)
      this.onDeleteConfirm();
    else
      this.handleClose();


  }

  onDeleteConfirm() {

    const { deleteCompany, companyId } = this.props;
    deleteCompany(companyId).then(() => {

      this.handleClose();
      this.getCompany();

    }, (errors) => {

      throw errors;

    });

  }

  handleClose = () => {

    this.props.setCompanyData({ open: false, companyData: null });
    this.setState({ data: {}, showTableActions: false, deleteOpen: false });

  }


  render() {

    const { companyList, open, consultMode } = this.props;
    const { data, showTableActions, deleteOpen } = this.state;


    return (
      <div>


        {!open && !deleteOpen
          && (
            <PageBase
              title={I18n.t('menu.company')}
              navigation={`Configurações -> ${I18n.t('menu.company')}`}
              showCreateButton={!showTableActions}
              showEditButton={showTableActions}
              showDeleteButton={showTableActions}
              handleCreateClick={this.handleCreateClick}
              handleEditClick={this.handleEditClick}
              handleDeleteClick={this.handleDeleteClick}
            >
              {
                companyList && (
                  <Table
                    data={companyList}
                    entryKey="idCompany"
                    paginate
                    onPaginate={this.onPaginate}
                    toolbar
                    onSelectionChange={this.onChangeData}
                    tableDef={[
                      { name: 'name', label: 'Nome' },
                      { name: 'cnpj', label: 'CNPJ' },
                    ]}
                  />
                )
              }


            </PageBase>
          )
        }


        <DeleteConfirmationDialog
          open={deleteOpen}
          onClose={this.closeDeleteDialog}
        />


      </div>
    );

  }

}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyContainer);



// WEBPACK FOOTER //
// ./src/components/tracker/Company/CompanyContainer.js